import { BaseQuery, QueryConfig, QueryResponse, QueryResult } from "@/shared/types/base";
import { removeNullOrEmptyKeys, sleep } from "@/shared/utils";
import { api } from "@/api";
import { useQuery } from "@tanstack/react-query";
import { ReactNode } from "react";
import { CuentaCorrienteItem, CuentaCorrienteItemTipo } from "@/shared/types/cuenta-corriente";

export interface CuentaCorrienteItemsQuery extends BaseQuery {
    desde?: string,
    hasta?: string,
    tipo?: CuentaCorrienteItemTipo
}

export async function getCuentaCorrienteItems(personaId: string, query?: CuentaCorrienteItemsQuery): Promise<QueryResponse<CuentaCorrienteItem>> {
    await sleep(1000);
    const response = await api.get("cuenta_corrientes/" + personaId + "/items", { params: removeNullOrEmptyKeys(query) });
    return response.data;
}

export function useGetCuentaCorrienteItemsQuery(personaId: string, query: CuentaCorrienteItemsQuery = {}, queryConfig: QueryConfig<QueryResponse<CuentaCorrienteItem>> = {}) {
    return useQuery({
        ...queryConfig,
        queryFn: async () => await getCuentaCorrienteItems(personaId, query),
        queryKey: ["cuenta_corrientes", personaId, "items", query],
    })
}

export interface GetCuentaCorrienteItemsQueryProps {
    personaId: string,
    query?: CuentaCorrienteItemsQuery,
    queryConfig?: QueryConfig<QueryResponse<CuentaCorrienteItem>>,
    children: (queryResult: QueryResult<QueryResponse<CuentaCorrienteItem>>) => ReactNode
}

export function GetCuentaCorrienteItemsQuery({
    personaId,
    query,
    queryConfig,
    children
}: GetCuentaCorrienteItemsQueryProps) {
    const queryResult = useGetCuentaCorrienteItemsQuery(personaId, query, queryConfig);
    return children && children(queryResult);
}